import { IFormSection, TSubmitType } from "../../types/common";
import { API_TICKET_CATEGORIZATION } from "../../utils/apis";
import { getRegister } from "../../utils/helpers";
import { URL_TICKET_CATEGORIZATION } from "../../utils/urls";

export type TFormCustomProps = {
  id?: number;
  submitType?: TSubmitType;
};

export const useTicketCategorizationForm = () => {
  const sections: IFormSection[] = [
    {
      title: "Ticket Categorization",
      fields: [
        {
          field_name: "name",
          type: "text",
          label: "Name",
          props: { required: true },
        },
        {
          field_name: "category_code",
          type: "text",
          label: "Category Code",
          props: { required: true },
        },

        {
          field_name: "description",
          type: "textarea",
          label: "Description",
          props: { required: true, wide: true },
        },
      ],
    },
  ];

  const redirect = getRegister(URL_TICKET_CATEGORIZATION);

  return { sections, redirect };
};

export function submitTicketCategorization(payload: any, id: number | null) {
  //  on update
  if (id) {
    return {
      id,
      api: API_TICKET_CATEGORIZATION,
      params: payload,
    };
  }
  // on create
  return {
    api: API_TICKET_CATEGORIZATION,
    params: payload,
  };
}
